import React from 'react';
import { Box } from '@material-ui/core';

interface DisabledRowOverlayProps {
  isDisabled: boolean;
}

const DisabledRowOverlay: React.FC<DisabledRowOverlayProps> = ({ isDisabled }) => {
  if (!isDisabled) return null;

  return (
    <Box
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1,
        cursor: 'not-allowed',
        pointerEvents: 'all',
      }}
    />
  );
};

export default DisabledRowOverlay;
